import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { ref, reactive } from "vue";
import type { FormInstance } from "element-plus";
import Decimal from "decimal.js";
import PaymentService from "../../services/PaymentService";
import { useI18n } from "vue-i18n";
import { ElNotification } from "element-plus";

export default /*#__PURE__*/_defineComponent({
  __name: 'CreateWalletAdjust',
  emits: ["eventSubmit"],
  setup(__props, { expose: __expose, emit: emits }) {

const t = useI18n().t;
const dialogRef = ref(false);
const isLoading = ref(false);
const ruleFormRef = ref<FormInstance>();
const formData = ref<any>({
  sourceType: 0,
  walletId: 0,
  amount: 0,
  comment: "",
});
const rules = reactive<any>({
  walletId: [
    { required: true, message: "Please input Login", trigger: "blur" },
  ],
  amount: [{ required: true, message: "Please input Amount", trigger: "blur" }],
  comment: [
    { required: true, message: "Please input Comment", trigger: "blur" },
  ],
});

const submit = async () => {
  if (!ruleFormRef.value) return;

  let isValid = false;
  await ruleFormRef.value.validate(async (valid, fields) => {
    isValid = valid;
  });
  if (!isValid) return;
  try {
    isLoading.value = true;
    const finalData = {
      amount: new Decimal(formData.value.amount).times(100).toNumber(),
      comment: formData.value.comment,
    };
    await PaymentService.createWalletAdjust(formData.value.walletId, finalData);
    ElNotification({
      title: "Success",
      message: "Wallet Adjusted",
      type: "success",
    });
    emits("eventSubmit");
    hide();
  } catch (error) {
    console.error(error);
    ElNotification({
      title: "Error",
      message: error,
      type: "error",
    });
  }
  isLoading.value = false;
};
const show = () => {
  dialogRef.value = true;
};
const hide = () => {
  dialogRef.value = false;
  formData.value = {
    sourceType: 0,
    walletId: 0,
    amount: 0,
    comment: "",
  };
};

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialogRef).value = $event)),
    title: "Wallet Adjust",
    width: "800",
    "align-center": ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (dialogRef.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          loading: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.submit")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: formData.value,
        rules: rules,
        "label-width": "120px",
        class: "demo-ruleForm",
        "status-icon": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "Adjust Type",
            prop: "sourceType"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.sourceType,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.sourceType) = $event)),
                disabled: isLoading.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Wallet Id",
            prop: "walletId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.walletId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.walletId) = $event)),
                disabled: isLoading.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('fields.amount'),
            prop: "amount"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.amount,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.amount) = $event)),
                disabled: isLoading.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('fields.comment'),
            prop: "comment"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.comment,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.comment) = $event)),
                disabled: isLoading.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})